import { Get, Post, Put, Delete } from "services";
import { ApiPath } from "paths";

export const searchResource = async (params) => {
  const res = await Post(`${ApiPath.SEARCH_RESOURCE}`, params);
  return res;
};

export const searchResourceStatus = async (params) => {
  const res = await Get(`${ApiPath.SEARCH_RESOURCE_STATUS}`, params);
  return res;
};

export const getResources = async ({ venueId }) => {
  const res = await Get(`${ApiPath.RESOURCE}`, { venueId });
  return res;
};

export const getResource = async ({ resourceId, ...body }) => {
  const res = await Get(`${ApiPath.RESOURCE_ID(resourceId)}`,body);
  return res;
};

export const createResource = async (payload) => {
  const res = await Post(`${ApiPath.RESOURCE}?venueId=${payload.venueId}&locationId=${payload.locationId}`, payload);
  return res;
};

export const editResource = async ({resourceId, ...payload}) => {
  const res = await Put(`${ApiPath.RESOURCE_ID(resourceId)}?venueId=${payload.venueId}&locationId=${payload.locationId}`, payload);
  return res;
};

export const deleteResource = async ({resourceId}) => {
  const res = await Delete(`${ApiPath.RESOURCE_ID(resourceId)}`);
  return res;
};

export const getResourceOccupancyGraph = async (body) => {
  const res = await Post(`${ApiPath.RESOURCE_STATUS_GRAPH(body.venueId)}`, body);
  return res;
};

export const getResourceStatusKpi = async (body) => {
  const res = await Post(`${ApiPath.RESOURCE_STATUS_KPI(body.venueId)}`, body);
  return res;
};

export const getResourceStatusTimeline = async ({ resourceId, ...params }) => {
  const res = await Get(`${ApiPath.RESOURCE_STATUS_TIMELINE(resourceId)}`, params);
  return res;
};

export const mapResourcesToZone = async ({ venueId, zoneId, resourceIds }) => {
  // token is optional, can be set via headers elsewhere
  const payload = {
    mapping: [
      {
        zoneId,
        resourceIds,
      },
    ],
  };
  const res = await Post(
    `${ApiPath.RESOURCE_MAPPING}?venueId=${venueId}`,
    payload
  );
  return res;
};
